import {useState} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {Accordion, Avatar, AvatarList} from 'shared/components';

const EventRow = observer(({event, date}) => {
  const {subjectEmployee} = event;

  return (
    <div className='WhatsGoingOn-row'>
      {subjectEmployee ?
        <span className='WhatsGoingOn-rowAvatar'>
          <Avatar employee={subjectEmployee} size='xs'/>
        </span> :
        <span className='WhatsGoingOn-dot'/>}
      <span className='WhatsGoingOn-rowTitle'>{event.titleOn(date)}</span>
      <div className='WhatsGoingOn-time'>
        {event.allDay ?
          <FormattedMessage id='hr_dashboard.whats_going_on.All day'/> :
          event.timeLabel}
      </div>
    </div>
  );
});

const GroupHeader = observer(({group, expanded, onToggle}) => {
  const hasAvatars = !_.isEmpty(group.employees);

  return (
    <div className='WhatsGoingOn-row clickable user-select-none' onClick={onToggle}>
      {hasAvatars ?
        <span className='WhatsGoingOn-rowAvatars'>
          <AvatarList employees={group.employees} limit={group.avatarLimit} size='xs'
            moreIndicator='ellipsis'/>
        </span> :
        <span className='WhatsGoingOn-dot'/>}
      <span className='WhatsGoingOn-rowTitle'>
        <FormattedMessage id={group.titleId} values={{count: group.count}}/>
      </span>
      <i className={`material-symbols-solid WhatsGoingOn-groupChevron ${expanded ? 'expanded' : ''}`}>
        {'chevron_right'}
      </i>
    </div>
  );
});

const EventGroupPanel = observer(({group, date}) => {
  const [expanded, setExpanded] = useState(false);
  const events = group.events.map(event => <EventRow key={event.key} event={event} date={date}/>);
  const className = `WhatsGoingOn-panel WhatsGoingOn-panel--${group.panelStyle}`;

  if (!group.collapsible) return <div className={className}>{events}</div>;

  return (
    <div className={className}>
      <GroupHeader group={group} expanded={expanded} onToggle={() => setExpanded(!expanded)}/>
      <Accordion active={expanded}>
        <div className='WhatsGoingOn-groupEvents'>{events}</div>
      </Accordion>
    </div>
  );
});

const EventList = observer(({agenda}) => {
  return (
    <div className='WhatsGoingOn-events'>
      {agenda.groups.map(group => <EventGroupPanel key={group.key} group={group} date={agenda.date}/>)}
    </div>
  );
});

export default EventList;
